import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import RequireAuth from './components/auth/RequireAuth';
import LoginPage from './pages/LoginPage';
import ProjectHubWrapper from './pages/ProjectHubWrapper';

function SessionExpiredModal() {
  const location = useLocation();
  const { sessionExpired, loginWithGoogle } = useAuth();

  if (!sessionExpired) {
    return null;
  }

  const redirectPath = `${location.pathname || ''}${location.search || ''}${location.hash || ''}` || '/';

  return (
    <div className="fixed inset-0 z-[100] bg-black bg-opacity-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md rounded-xl shadow-xl p-6" style={{background:'var(--tqa-surface)',border:'1px solid var(--tqa-border-dark)'}}>
        <h2 className="text-xl font-semibold mb-2" style={{color:'rgba(255,255,255,0.9)'}}>Session expired</h2>
        <p className="text-sm mb-5" style={{color:'rgba(255,255,255,0.6)'}}>  
          Your login session is no longer valid, usually after a server restart. Please log in again to continue.
        </p>
        <button
          type="button"
          onClick={() => loginWithGoogle(redirectPath)}
          className="w-full btn-primary py-2.5"
        >
          Login
        </button>
      </div>
    </div>
  );
}

function AppContent() {
  return (
    <div className="App h-screen flex flex-col overflow-hidden">
      <div className="flex-1 overflow-hidden">
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/*"
            element={(
              <RequireAuth>
                <ProjectHubWrapper />
              </RequireAuth>
            )}
          />
        </Routes>
      </div>
      <SessionExpiredModal />
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;